var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Store, Select, Actions, ofActionDispatched, ofActionCompleted } from '@ngxs/store';
import { SetReady, SetEngineChapterInit, SynchronizeVisibleNodes, SetEngineChapter, ClickNode, FlyToObject, SynchronizeRenderableNodes, PlayAnimation, ShowScrollAlert } from '../../state/engine.actions';
import { EngineState } from '../../state/engine.state';
import { Observable, fromEvent, BehaviorSubject, combineLatest, Subject, interval, merge } from 'rxjs';
import { filter, takeUntil, bufferTime, debounceTime, throttle, pairwise } from 'rxjs/operators';
import { EngineService } from '../../engine.service';
import { environment } from 'src/environments/environment';
import { CameraService } from '../../camera.service';
import { EngineVisibilityEnum } from '../../models/engine-visibility.enum';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { PaintService } from '../../paint.service';
import { SetCamera, MoveCamera, PanCameraStatic, RotateCameraStatic, ZoomCameraStatic } from '../../state/camera/engine.camera.actions';
import { CameraMotionModel } from '../../models/camera-motion.model';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { AnimationService } from '../../animation.service';
import { BackgroundModel } from '../../models/background.model';
import { HoverNode, UnpaintNodes } from '../../state/nodes/engine.nodes.actions';
import { EngineNodesState } from '../../state/nodes/engine.nodes.state';
import { get, isEmpty } from 'lodash';
import * as Hammer from 'hammerjs';
import { EventsEnum } from '../../models/events.enum';
import { StoryState } from 'src/app/story/state/story.state';
import { SetProgress } from '../../state/progress/engine.progress.actions';
import { LoadStoryChunkSuccess } from 'src/app/story/state/story.actions';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { PaintPresetFade } from '../../models/paint-presets.const';
import { ScrollModeEnum } from '../../models/scroll-mode.enum';
import { disableXrayMode } from 'src/app/shared/xray-mode';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
var KeyboardCamera;
(function (KeyboardCamera) {
    KeyboardCamera[KeyboardCamera["Pan"] = 0.4] = "Pan";
    KeyboardCamera[KeyboardCamera["PanSlow"] = 0.04] = "PanSlow";
    KeyboardCamera[KeyboardCamera["Zoom"] = 5] = "Zoom";
    KeyboardCamera[KeyboardCamera["ZoomSlow"] = 1] = "ZoomSlow";
    KeyboardCamera[KeyboardCamera["Rotate"] = 0.3] = "Rotate";
    KeyboardCamera[KeyboardCamera["RotateSlow"] = 0.03] = "RotateSlow";
})(KeyboardCamera || (KeyboardCamera = {}));
var MouseCamera;
(function (MouseCamera) {
    MouseCamera[MouseCamera["Rotate"] = 6] = "Rotate";
    MouseCamera[MouseCamera["Pan"] = 1.75] = "Pan";
    MouseCamera[MouseCamera["Zoom"] = 2] = "Zoom";
})(MouseCamera || (MouseCamera = {}));
var TouchCamera;
(function (TouchCamera) {
    TouchCamera[TouchCamera["Zoom"] = -12] = "Zoom";
    TouchCamera[TouchCamera["Pan"] = 2.5] = "Pan";
    TouchCamera[TouchCamera["Rotate"] = 1.5] = "Rotate";
    TouchCamera[TouchCamera["Pinch"] = 1.5] = "Pinch";
})(TouchCamera || (TouchCamera = {}));
var CursorClasses;
(function (CursorClasses) {
    CursorClasses["Hide"] = "engine--cursor-hide";
    CursorClasses["Label"] = "engine--cursor-label";
    CursorClasses["Paint"] = "engine--cursor-paint";
    CursorClasses["Crosshair"] = "engine--cursor-crosshair";
    CursorClasses["Default"] = "";
})(CursorClasses || (CursorClasses = {}));
var MouseButtons;
(function (MouseButtons) {
    MouseButtons[MouseButtons["None"] = 0] = "None";
    MouseButtons[MouseButtons["Left"] = 1] = "Left";
    MouseButtons[MouseButtons["Right"] = 2] = "Right";
    MouseButtons[MouseButtons["LeftAndRight"] = 4] = "LeftAndRight";
})(MouseButtons || (MouseButtons = {}));
const zoomVelocity = 10;
export class EngineComponent {
    constructor(actions, animationService, cameraService, changeDetecton, engineEventsService, paintService, renderer, store, graphService) {
        this.actions = actions;
        this.animationService = animationService;
        this.cameraService = cameraService;
        this.changeDetecton = changeDetecton;
        this.engineEventsService = engineEventsService;
        this.paintService = paintService;
        this.renderer = renderer;
        this.store = store;
        this.graphService = graphService;
        this.flyCamera = true;
        this.chapterActivating = false;
        this.visible = false;
        this.cursorClass = CursorClasses.Default;
        this.mouseDelta = null;
        this.ngUnsubscribe = new Subject();
        this.hoveredNode = null;
        this.display = false;
        this.engineVisible = true;
        this.ctrlPressed = false;
        this.scrollType = null;
        this.scrollTimeout = null;
        this.zoomVelocity = 0;
        this.inputEnabled = true;
    }
    get isTransparentBackground() {
        if (this.background) {
            return BackgroundModel.isTransparent(this.background);
        }
        else {
            return false;
        }
    }
    get isBackgroundCheckered() {
        return environment.application !== EnvironmentApplication.Viewer && this.isTransparentBackground;
    }
    wheel(event) {
        const scrollMode = this.store.selectSnapshot(EngineState.getScrollMode);
        const ctrlActive = this.ctrlPressed;
        if (scrollMode === ScrollModeEnum.DoNotCaptureShowMessage && !ctrlActive) {
            this.store.dispatch(new ShowScrollAlert(true));
        }
        if (scrollMode !== ScrollModeEnum.Capture && !ctrlActive) {
            return;
        }
        // if we're allowed to scroll, we never want the parent window to scroll
        event.preventDefault();
        this.handleWheel(event);
    }
    contextmenu(event) {
        this.handleContextMenu(event);
    }
    mouseout() {
        this.handleMouseOut();
    }
    // map single property state map to graph state map
    convertToLeafStateMap(property, propertyMap) {
        const leafStateMap = {};
        Object.entries(propertyMap).forEach(([id, state]) => {
            leafStateMap[id] = {};
            leafStateMap[id][property] = state;
        });
        return leafStateMap;
    }
    ngOnInit() {
        this.bindEngineEvents();
        this.bindApplicationEvents();
        this.bindUserEvents();
        this.bindKeyEvents();
        this.bindHumanInteractions();
        this.renderer.listen(window, 'keydown', (e) => {
            if (e.key === 'Control') {
                this.ctrlPressed = true;
            }
        });
        this.renderer.listen(window, 'keyup', (e) => {
            if (e.key === 'Control') {
                this.ctrlPressed = false;
            }
        });
        Human.properties.set({ assetDomain: environment.assetDomain });
        Human.workers.setPath('/assets/engine/studio/workers');
        Human.init.init();
    }
    ngOnDestroy() {
        this.changeDetecton.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    initEventListeners() {
    }
    bindEngineEvents() {
        // Graph has initialized
        this.engineEventsService.getEvent(EventsEnum.Loaded)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.store.dispatch(new SetReady(true));
        });
        // Chapters have started activating
        this.engineEventsService.getEvent(EventsEnum.TimelineChaptersActivateStart)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.chapterActivating = true;
        });
        // Chapters have finished
        this.engineEventsService.getEvent(EventsEnum.TimelineChaptersActivateFinish)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((params) => {
            this.chapterActivating = false;
            const currentBranch = Human.timeline.activeRoot._nowBranch;
            const chapterInit = {
                id: currentBranch.id,
                init: true,
                camera: currentBranch.initializedCamera,
                annotations: currentBranch.initializedAnnotations,
                graph: currentBranch.initializedGraph,
                properties: currentBranch.initializedProperties,
                particles: currentBranch.initializedParticles,
                clips: currentBranch.initializedClippingPlanes,
                postprocessing: currentBranch.initializedPostprocess,
                transparency: currentBranch.initializedTransparencyMode
            };
            this.store.dispatch(new SetEngineChapter(params.chapterId));
            this.store.dispatch(new SetEngineChapterInit(chapterInit));
        });
        // Handle engine tick, but only when it's visible
        this.engineEventsService.getEvent(EventsEnum.Tick)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            if (this.visible) {
                if (this.inputEnabled) {
                    this.handleMouseInputEngineTick();
                }
                this.handleCameraTick();
            }
        });
        // Handle object visibility event
        this.engineEventsService.getEvent(EventsEnum.SceneObjectsShown)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((params) => {
            if (!this.chapterActivating) {
                const stateMap = this.convertToLeafStateMap('shown', params.enabledObjectsUpdate);
                this.store.dispatch(new SynchronizeVisibleNodes(stateMap));
            }
        });
        // Handle object renderable event
        this.engineEventsService.getEvent(EventsEnum.SceneObjectRenderable)
            .pipe(bufferTime(1000), takeUntil(this.ngUnsubscribe))
            .subscribe((renderable) => {
            if (renderable.length) {
                const leafStateMap = {};
                renderable.forEach(renderableData => {
                    leafStateMap[renderableData.objectId] = { 'renderable': true };
                });
                this.store.dispatch(new SynchronizeRenderableNodes(leafStateMap));
            }
        });
        // Handle Loading
        this.engineEventsService
            .getEvent(EventsEnum.AssetsLoadProgress)
            .pipe(takeUntil(this.ngUnsubscribe), throttle(() => interval(250)))
            .subscribe((progress) => {
            const totalChunks = this.store.selectSnapshot(StoryState.getLoadChunks).length;
            const remainingChunks = this.store.selectSnapshot(StoryState.getLoadChunksRemaining).length;
            const currentChunkIdx = totalChunks - remainingChunks;
            const { receivedAssets, requestedAssets } = progress;
            const currentChunkProgress = receivedAssets / requestedAssets;
            const chunkWidth = 1 / totalChunks;
            const baseProgress = currentChunkIdx * chunkWidth;
            const currentProgress = currentChunkProgress * chunkWidth;
            const storyLoadProgress = currentProgress + baseProgress;
            this.store.dispatch(new SetProgress(storyLoadProgress, currentChunkProgress));
        });
        // There are story load chunks that don't actually initiate any downloading.
        // Therefore, we can only know when loading has completed by pipeing LoadStoryChunkSuccess, and there are zero chunks remaining
        this.actions
            .pipe(ofActionCompleted(LoadStoryChunkSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            const chunksRemaining = this.store.selectSnapshot(StoryState.getLoadChunksRemaining).length;
            if (chunksRemaining === 0) {
                this.store.dispatch(new SetProgress(1, 1));
            }
        });
        // timeline: playing
        this.engineEventsService.getEvent(EventsEnum.TimelinePlayed)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.store.dispatch(new PlayAnimation(true));
        });
        // timeline: stopped
        merge(this.engineEventsService.getEvent(EventsEnum.TimelinePaused), this.engineEventsService.getEvent(EventsEnum.TimelineStopped))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.store.dispatch(new PlayAnimation(false));
        });
    }
    highlightXrayMode(checkedNodes) {
        const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        const uncheckedNodeIds = this.graphService.getInverseSelection(viewGraph, checkedNodes.map(node => node.id));
        const uncheckedNodes = this.graphService.getNodes(viewGraph, uncheckedNodeIds);
        uncheckedNodes.forEach(node => this.paintService.paint(node, PaintPresetFade.recipe));
        this.store.dispatch(new UnpaintNodes(checkedNodes));
    }
    highlightDefaultMode(checkedNodes, uncheckedNodes) {
        this.paintService.highlightAll(uncheckedNodes, false);
        this.paintService.highlightAll(checkedNodes, true);
    }
    bindApplicationEvents() {
        // Available screen space for the engine has changed
        this.enginePosition$
            .pipe(filter(position => position != null), takeUntil(this.ngUnsubscribe))
            .subscribe((position) => {
            this.repositionEngine(position);
        });
        this.checkedNodes$
            .pipe(takeUntil(this.ngUnsubscribe), pairwise())
            .subscribe((nodes) => {
            const [previouslySelected, currentlySelected] = nodes;
            if (this.store.selectSnapshot(EngineState.getXrayModeEnabled)) {
                this.highlightXrayMode(currentlySelected);
            }
            else {
                this.highlightDefaultMode(currentlySelected, previouslySelected);
            }
            // notify selection updates
            const selectedObjectsUpdate = this.calculateSelectedObjectsUpdate(previouslySelected || [], currentlySelected || []);
            // only fire the event if there is an updated
            if (!isEmpty(selectedObjectsUpdate)) {
                this.engineEventsService.fireEvent(EventsEnum.SceneObjectsSelected, { selectedObjectsUpdate });
            }
        });
        this.store.select(EngineState.getXrayModeEnabled)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(xrayModeEnabled => {
            // get checked and unchecked nodes.
            const checkedNodes = this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
            // when toggling xray mode,
            // we have to refresh the way objects are presented, based on the currently selected nodes.
            if (xrayModeEnabled === false) {
                // re-paint leaf nodes
                this.store.selectSnapshot(EngineState.getXrayCachedColorRecipes).forEach(recipe => this.paintService.colorObject(recipe.objectId, recipe.recipe));
                // re-highlight checked nodes
                this.highlightDefaultMode(checkedNodes, []);
            }
            else { // xray mode is enabled
                // turn off the highlighting for the checked nodes
                this.paintService.highlightAll(checkedNodes, false);
                // highlight xray mode for checked nodes.
                this.highlightXrayMode(checkedNodes);
            }
        });
        this.actions.pipe(ofActionDispatched(SetCamera), takeUntil(this.ngUnsubscribe)).subscribe((action) => action.animate
            ? this.flyToPoint(action.camera, action.animationDuration)
            : this.jumpToPoint(action.camera));
        this.actions.pipe(ofActionDispatched(PanCameraStatic), takeUntil(this.ngUnsubscribe)).subscribe((action) => {
            this.cameraService.panCameraStatic(action.x, action.y, action.z);
        });
        this.actions.pipe(ofActionDispatched(RotateCameraStatic), takeUntil(this.ngUnsubscribe)).subscribe((action) => {
            this.cameraService.rotateCameraStatic(action.x, action.y);
        });
        this.actions.pipe(ofActionDispatched(ZoomCameraStatic), takeUntil(this.ngUnsubscribe)).subscribe((action) => {
            this.cameraService.setHumanZoomFactor(action.value);
        });
        this.actions.pipe(ofActionDispatched(FlyToObject), filter((action) => !!action.objectId), takeUntil(this.ngUnsubscribe)).subscribe((action) => {
            action.animate
                ? this.flyToObject(action.objectId, action.animationDuration)
                : this.jumpToObject(action.objectId);
        });
        // New chapter
        this.selectedChapter$
            .pipe(filter((chapter) => {
            return chapter != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe((chapter) => {
            // xray mode needs to be disabled when changing chapter
            disableXrayMode(this.store, this.engineEventsService);
            // set background
            this.background = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
            Human.timeline.scrub({ chapterId: chapter.id });
        });
        this.background$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((background) => {
            this.background = background;
        });
        // Selected tool changed
        this.activeTool$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((tool) => {
            // Reset hover class
            Object.values(CursorClasses).forEach(cursorClass => {
                if (cursorClass) {
                    this.renderer.removeClass(this.engineElement.nativeElement, cursorClass);
                }
            });
            switch (tool) {
                case ToolEnum.Hide:
                    this.renderer.addClass(this.engineElement.nativeElement, CursorClasses.Hide);
                    break;
                case ToolEnum.Label:
                    this.renderer.addClass(this.engineElement.nativeElement, CursorClasses.Label);
                    break;
                case ToolEnum.Paint:
                    this.renderer.addClass(this.engineElement.nativeElement, CursorClasses.Paint);
                    break;
                case ToolEnum.Isolate:
                case ToolEnum.Fade:
                    this.renderer.addClass(this.engineElement.nativeElement, CursorClasses.Crosshair);
                    break;
                default:
                    // Do nothing for now
                    break;
            }
        });
        // Chapter animation
        combineLatest(this.selectedChapter$, this.animationPlaying$)
            .pipe(filter(([chapter]) => chapter != null), takeUntil(this.ngUnsubscribe))
            .subscribe(([chapter, playing]) => {
            const playCount = get(chapter, 'ui.play.count') || 0;
            if (this.animationService.isChapterAnimated(chapter) && chapter.readyState.animation && playing) {
                this.animationService.play({
                    startChapterId: chapter.id,
                    loop: (playCount === -1),
                    numChapters: 1,
                    queue: false // True for higher playcount
                });
            }
            else {
                this.animationService.pause();
            }
        });
        // display
        this.engineDisplay$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((display) => {
            this.display = display;
            this.changeDetecton.markForCheck();
        });
        // visibility
        this.engineVisible$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((visible) => {
            this.engineVisible = visible;
            this.changeDetecton.markForCheck();
        });
    }
    bindUserEvents() {
        // User moves mouse, debounce to small delay so lookup only occurs on pause.
        // Done for performance, doing a node lookup in 3D is expensive.
        this.mouseMove$ = fromEvent(this.engineElement.nativeElement, 'mousemove');
        // Handle all mouse move events, primarily for panning the camera
        this.mouseMove$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
            this.handleMousePan(event);
        });
        // User moves mouse, debounce to small delay so  hover lookup only occurs on pause.
        // Done for performance, doing a node lookup in 3D is expensive.
        this.mouseMove$.pipe(debounceTime(10), takeUntil(this.ngUnsubscribe)).subscribe((event) => {
            this.handleMouseHover(event);
        });
    }
    bindKeyEvents() {
        const downKeys = ['w', 'a', 's', 'd', 'e', 'c', '=', '-', '+', '_', 'arrowleft', 'arrowright', 'arrowup', 'arrowdown', 'shiftKey']
            .reduce((result, value) => {
            result[value] = false;
            return result;
        }, {});
        const downKeys$ = new BehaviorSubject(downKeys);
        this.renderer.listen(window, 'keydown', (event) => {
            if (event.repeat || event.metaKey || event.ctrlKey) {
                return;
            }
            // Prevent keyboard events while inputs are focused
            const eventNode = event.target.nodeName.toLowerCase();
            if (['input', 'textarea', 'select', 'option'].indexOf(eventNode) >= 0) {
                return;
            }
            downKeys$.next(Object.assign({}, downKeys$.value, { [event.key.toLowerCase()]: true, shiftKey: event.shiftKey }));
        });
        this.renderer.listen(window, 'keyup', (event) => {
            if (event.key) {
                downKeys$.next(Object.assign({}, downKeys$.value, { [event.key.toLowerCase()]: false, shiftKey: event.shiftKey }));
            }
        });
        downKeys$
            .pipe(
        // validate input enabled state
        filter(() => this.inputEnabled), takeUntil(this.ngUnsubscribe))
            .subscribe(value => {
            const motion = new CameraMotionModel();
            const zoom = value.shiftKey ? KeyboardCamera.ZoomSlow : KeyboardCamera.Zoom;
            const pan = value.shiftKey ? KeyboardCamera.PanSlow : KeyboardCamera.Pan;
            const rotate = value.shiftKey ? KeyboardCamera.RotateSlow : KeyboardCamera.Rotate;
            motion.zoom += (value.c || value['-'] || value['_']) ? zoom : 0;
            motion.zoom -= (value.e || value['='] || value['+']) ? zoom : 0;
            motion.panX -= value.d ? pan : 0;
            motion.panX += value.a ? pan : 0;
            motion.panY += value.w ? pan : 0;
            motion.panY -= value.s ? pan : 0;
            motion.rotateX -= value.arrowright ? rotate : 0;
            motion.rotateX += value.arrowleft ? rotate : 0;
            motion.rotateY += value.arrowup ? rotate : 0;
            motion.rotateY -= value.arrowdown ? rotate : 0;
            this.store.dispatch(new MoveCamera(motion));
        });
    }
    repositionEngine(position) {
        this.renderer.setStyle(this.engineElement.nativeElement, 'left', `${position.left}px`);
        this.renderer.setStyle(this.engineElement.nativeElement, 'top', `${position.top}px`);
        this.renderer.setStyle(this.engineElement.nativeElement, 'width', `${position.width}px`);
        this.renderer.setStyle(this.engineElement.nativeElement, 'height', `${position.height}px`);
        this.renderer.setStyle(this.engineElement.nativeElement, 'zIndex', `${position.visibility}`);
        this.renderer.setStyle(this.engineElement.nativeElement, 'visibility', (position.visibility === EngineVisibilityEnum.Shown) ? 'visible' : 'hidden');
        // Engine user interaction will be disabled when the engine isn't visible
        this.visible = position.visibility === EngineVisibilityEnum.Shown;
        Human.renderer.resize();
    }
    /**
     * User Interactions
     * Depends on the HammerJS library to ensure touch compatibility, and manage pan handlers (heh...)
     */
    bindHumanInteractions() {
        // Create a HammerJS manager so we can custom define single and double click
        const mc = new Hammer.Manager(this.engineCanvasElement.nativeElement);
        // Tap recognizer with minimal 2 taps
        mc.add(new Hammer.Tap({ event: 'doubletap', taps: 2 }));
        // Single tap recognizer
        mc.add(new Hammer.Tap({ event: 'singletap' }));
        // Pan recognizer
        mc.add(new Hammer.Pan({ event: 'pan', pointers: 0 }));
        // Ping
        mc.add(new Hammer.Pinch());
        // Press
        mc.add(new Hammer.Press({ time: 500 }));
        mc.on('singletap', (event) => {
            this.handleTap(event);
        });
        mc.on('doubletap', (event) => {
            this.handleDoubleTap(event);
        });
        mc.on('press', (event) => {
            this.handlePress(event);
        });
        mc.on('pan', (event) => {
            event.preventDefault();
            this.handlePan(event);
        });
        let cacheScale = 0;
        let cacheX = 0;
        let cacheY = 0;
        let mode = '';
        mc.on('pinchstart', (event) => {
            cacheScale = event.scale;
            cacheX = event.deltaX;
            cacheY = event.deltaY;
            mode = '';
        });
        mc.on('pinchmove', (event) => {
            const panDistanceMet = Math.abs(event.deltaX) > 15 || Math.abs(event.deltaY) > 15;
            const pinchScaleMet = event.scale > 1.1 || event.scale < 0.9;
            // Determine is user is panning or pinching
            if (!mode) {
                mode = panDistanceMet ? 'pan' : 'pinch';
            }
            else {
                if (mode === 'pan' && pinchScaleMet && !panDistanceMet) {
                    mode = 'pinch';
                }
                if (mode === 'pinch' && panDistanceMet && !pinchScaleMet) {
                    mode = 'pan';
                }
            }
            const scale = event.scale - cacheScale;
            cacheScale = event.scale;
            switch (mode) {
                case 'pan':
                    this.cameraService.setCameraPan(event.velocityX, event.velocityY * TouchCamera.Pinch);
                    break;
                case 'pinch':
                    Human.renderer.camera.zoom(scale * TouchCamera.Zoom);
                    break;
                default:
                    this.cameraService.setCameraPan(event.velocityX, event.velocityY * TouchCamera.Pinch);
                    Human.renderer.camera.zoom(scale * TouchCamera.Zoom);
            }
        });
    }
    handleMouseHover(event) {
        if (event.buttons !== MouseButtons.None) {
            return;
        }
        const { offsetX, offsetY } = event;
        const hit = Human.renderer.pick.pick(offsetX, offsetY);
        if (hit.objectId) {
            const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            const hitNode = this.engineEventsService.getNode(viewGraph, hit.objectId);
            const hoveredNode = this.store.selectSnapshot(EngineNodesState.getHoveredNode);
            if (!hoveredNode || hoveredNode.id !== hitNode.id) {
                this.store.dispatch(new HoverNode(hitNode, hit));
            }
        }
        else {
            if (this.store.selectSnapshot(EngineNodesState.getHoveredNode) != null) {
                this.store.dispatch(new HoverNode(null));
            }
        }
    }
    handleMousePan(event) {
        // Left mouse button is handled by HammerJS 'pan'
        if (event.buttons === 2 || event.buttons === 4) {
            let { movementX, movementY } = event;
            movementX /= 20;
            movementY /= 20;
            this.cameraService.setCameraPan(movementX, movementY);
        }
    }
    handleMouseOut() {
        this.store.dispatch(new HoverNode(null));
    }
    // When it comes to wheel events, we account for both trackpad and scroll wheel. The deltaY
    // from these events can vary wildly between trackpad, mouse type, and browser. Read the docs
    // below to learn more.
    // https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent
    handleWheel(event) {
        let deltaY = 0;
        // Check deltaMode, which determines if we're pixel / line / page scrolling
        switch (event.deltaMode) {
            case 0: // Pixel delta (most common, trackpad and mice scroll wheels in Chrome & Safari)
                // Best attempt at determining trackpad vs wheel. 
                // On initial scroll, a trackpad never starts off higher than 10 pixels movement.
                if (this.scrollType === null) {
                    this.scrollType = (Math.abs(event.deltaY) < 10) ? 'trackpad' : 'wheel';
                }
                // If trackpad, use deltaY
                // Otherwise use fixed scroll speed
                deltaY = (this.scrollType === 'trackpad') ?
                    event.deltaY :
                    Math.sign(event.deltaY) * zoomVelocity;
                break;
            default: // Line delta (less common, mice scroll wheels in Firefox)
                this.scrollType = 'wheel';
                break;
        }
        // Reset checking tracker. After 500ms of inactivity, reset scroll tracker.
        // Do this so that users transitioning between mouse and trackpad don't have issues.
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
            this.scrollType = null;
        }, 500);
        // Don't allow zoom to exceed max
        if (Math.abs(deltaY) > 40) {
            deltaY = Math.sign(deltaY) * 40;
        }
        // For trackpad, use pixel precision.
        if (this.scrollType === 'trackpad') {
            this.cameraService.setCameraZoom(deltaY);
            // For wheel, use fixed velocity
        }
        else {
            this.zoomWithVelocity(deltaY);
        }
    }
    zoomWithVelocity(deltaY) {
        this.cameraService.setCameraZoom(deltaY);
        requestAnimationFrame(() => {
            deltaY *= 0.85;
            if (Math.abs(deltaY) > 1) {
                this.zoomWithVelocity(deltaY);
            }
        });
    }
    handleContextMenu(event) {
        event.preventDefault();
        const { offsetX, offsetY } = event;
        const hit = this.getHit(offsetX, offsetY);
        const node = this.getNodeFromHit(hit);
    }
    handleTap(event) {
        const { offsetX, offsetY } = this.getOffset(event);
        const hit = this.getHit(offsetX, offsetY);
        const node = this.getNodeFromHit(hit);
        this.store.dispatch(new ClickNode(node, event, hit));
    }
    handleDoubleTap(event) {
        const { offsetX, offsetY } = this.getOffset(event);
        const hit = this.getHit(offsetX, offsetY);
        const node = this.getNodeFromHit(hit);
        if (node) {
            this.store.dispatch(new FlyToObject(node.id));
        }
    }
    handlePress(event) {
        const { offsetX, offsetY } = this.getOffset(event);
        const hit = this.getHit(offsetX, offsetY);
        const node = this.getNodeFromHit(hit);
        if (node) {
            this.store.dispatch(new FlyToObject(node.id));
        }
    }
    handlePan(event) {
        const panMode = this.store.selectSnapshot(EngineCameraState.getPanMode);
        if (event.srcEvent.shiftKey || panMode === 'pan') {
            let { movementX, movementY } = event.srcEvent;
            movementX /= 20;
            movementY /= 20;
            this.cameraService.setCameraPan(movementX, movementY);
        }
        else {
            this.cameraService.setCameraRotation(event.velocityX * TouchCamera.Rotate, event.velocityY * TouchCamera.Rotate);
        }
    }
    handleMouseInputEngineTick() {
        const rotation = this.cameraService.tickCameraRotation();
        const pan = this.cameraService.tickCameraPan();
        const zoom = this.cameraService.tickCameraZoom();
        // Rotation
        if (rotation.vx || rotation.vy) {
            this.cameraService.rotateCameraStatic(rotation.vx !== 0 ? rotation.vx * MouseCamera.Rotate : 0, rotation.vy !== 0 ? rotation.vy * MouseCamera.Rotate : 0);
        }
        // Pan
        if (pan.x || pan.y) {
            const f = Math.max(Human.renderer.camera.lookDistance / 80, 0.01);
            this.cameraService.panCameraStatic((pan.x * f) * MouseCamera.Pan, (pan.y * f) * MouseCamera.Pan, (pan.z * f) * MouseCamera.Pan);
        }
        // Zoom
        if (zoom !== 0) {
            this.cameraService.setHumanZoom(zoom * MouseCamera.Zoom);
        }
    }
    handleCameraTick() {
        const motion = this.store.selectSnapshot(EngineCameraState.getCameraMotion);
        // PAN
        this.cameraService.setCameraPan(motion.panX, motion.panY);
        this.cameraService.setCameraRotation(motion.rotateX, motion.rotateY);
        this.cameraService.setCameraZoom(motion.zoom);
    }
    flyToObject(objectId, animationDuration) {
        Human.renderer.camera.fly.flyTo({
            objectId,
            animationDuration
        });
    }
    jumpToObject(objectId) {
        Human.renderer.camera.fly.jumpTo({ objectId });
    }
    flyToPoint(destination, animationDuration) {
        Human.renderer.camera.fly.flyTo(Object.assign({}, destination, { animationDuration }));
    }
    jumpToPoint(destination) {
        Human.renderer.camera.fly.jumpTo(destination);
    }
    getNodeFromHit(hit) {
        let node;
        if (hit.objectId) {
            const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            node = this.engineEventsService.getNode(viewGraph, hit.objectId);
        }
        return node;
    }
    getHit(x, y) {
        // For clicks, set rayPick to true so we get a completely detailed hit object
        // that includes the exact triangle the user clicked on. This is different 
        // from hover, that only target the general node. 
        const hit = Human.renderer.pick.pick(x, y, { rayPick: true });
        return hit;
    }
    getContainerStyles() {
        const styles = {};
        // set background
        if (this.background && !this.isTransparentBackground) {
            styles['background-image'] = BackgroundModel.toCSS(this.background);
        }
        // set display
        if (!this.display) {
            styles['display'] = 'none';
        }
        // set transparent
        if (!this.engineVisible) {
            styles['opacity'] = 0;
        }
        return styles;
    }
    // We calculate offsetX and offsetY using rect and center because iOS safari
    // does not natively support offsetX and offsetY. Those properties return `undefined`
    // when requested. 
    // More: http://www.jacklmoore.com/notes/mouse-position/
    getOffset(event) {
        let x = 0;
        let y = 0;
        if (event.center) {
            x = event.center.x;
            y = event.center.y;
        }
        else {
            x = event.clientX;
            y = event.clientY;
        }
        const target = this.engineElement.nativeElement;
        const rect = target.getBoundingClientRect();
        return {
            offsetX: x - rect.left,
            offsetY: y - rect.top
        };
    }
    calculateSelectedObjectsUpdate(previouslySelected, currentlySelected) {
        const previousSelectedState = this.createNodeStateMap(previouslySelected, false);
        const currentlySelectedState = this.createNodeStateMap(currentlySelected, true);
        return Object.assign({}, previousSelectedState, currentlySelectedState);
    }
    createNodeStateMap(nodes, state) {
        return nodes.reduce((acc, node) => {
            acc[node.id] = state;
            return acc;
        }, {});
    }
}
__decorate([
    Select(EngineState.getReady),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "ready$", void 0);
__decorate([
    Select(EngineState.getViewGraph),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "viewGraph$", void 0);
__decorate([
    Select(EngineState.getEnginePosition),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "enginePosition$", void 0);
__decorate([
    Select(EngineNodesState.getHoveredNode),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "hoveredNode$", void 0);
__decorate([
    Select(EngineState.getChapter),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "chapter$", void 0);
__decorate([
    Select(EngineState.getChapterInit),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "chapterInit$", void 0);
__decorate([
    Select(EngineNodesState.getCheckedNodes),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "checkedNodes$", void 0);
__decorate([
    Select(EngineState.getActiveTool),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "activeTool$", void 0);
__decorate([
    Select(EngineState.getAnimationPlaying),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "animationPlaying$", void 0);
__decorate([
    Select(EngineState.getDisplay),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "engineDisplay$", void 0);
__decorate([
    Select(EngineState.getVisible),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "engineVisible$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapter),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "selectedChapter$", void 0);
__decorate([
    Select(EngineCameraState.getCameraMotion),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "cameraMotion$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterBackground),
    __metadata("design:type", Observable)
], EngineComponent.prototype, "background$", void 0);
